import { Component } from '@theme/component';
import { isClickedOutside } from '@theme/utilities';

/**
 * @typedef {object} DropdownRefs
 * @property {HTMLButtonElement} button
 * @property {HTMLElement} panel
 */

/** @extends {Component<DropdownRefs>} */
class WtHeaderAddresses extends Component {
  /** @type {string[] | undefined} */
  requiredRefs = ['button', 'panel'];

  get isHidden() {
    return this.refs.panel.hasAttribute('hidden');
  }

  connectedCallback() {
    super.connectedCallback();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  toggle() {
    return this.isHidden ? this.showPanel() : this.hidePanel();
  }

  showPanel() {
    if (!this.isHidden) return;

    this.addEventListener('keyup', this.#handleKeyUp);
    document.addEventListener('click', this.#handleClickOutside);

    this.refs.panel.removeAttribute('hidden');
    this.refs.button.setAttribute('aria-expanded', 'true');
  }

  hidePanel = () => {
    if (this.isHidden) return;

    this.removeEventListener('keyup', this.#handleKeyUp);
    document.removeEventListener('click', this.#handleClickOutside);

    this.refs.button.setAttribute('aria-expanded', 'false');
    this.refs.panel.setAttribute('hidden', '');
  };

  /** @param {MouseEvent} event */
  #handleClickOutside = (event) => {
    if (isClickedOutside(event, this)) {
      this.hidePanel();
    }
  };

  /** @param {KeyboardEvent} event */
  #handleKeyUp = (event) => {
    if (event.key !== 'Escape') return;
    this.hidePanel();
    event.stopPropagation();
    this.refs.button.focus();
  };
}

customElements.define('wt-header-addresses', WtHeaderAddresses);
